import { motion } from 'framer-motion';
import { LANDING_SECTION_IDS } from './constants';

const STEPS = [
  {
    step: '01',
    title: 'Create your community',
    description:
      'Set up your space, invite admins, and define how members join — open, invite-only, or approval-based.',
  },
  {
    step: '02',
    title: 'Configure your modules',
    description:
      'Enable events, business directory, projects, and more. Turn features on or off as your community grows.',
  },
  {
    step: '03',
    title: 'Engage your members',
    description:
      'Publish posts, announcements, and updates. Keep members active with a feed built for community interaction.',
  },
  {
    step: '04',
    title: 'Capture real outcomes',
    description:
      'Track leads, event attendance, directory visibility, and engagement — so you know what is working.',
  },
] as const;

export function HowItWorksSection() {
  return (
    <section id={LANDING_SECTION_IDS.howItWorks} className="py-24 scroll-mt-24">
      <div className="container px-6 mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16 space-y-4">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">How it works</h2>
          <p className="text-muted-foreground text-lg">
            From setup to growth — a simple path for community owners.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((item, index) => (
            <motion.div
              key={item.step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="relative rounded-2xl border border-border/50 bg-background p-6 shadow-sm"
            >
              <span className="text-4xl font-black text-primary/20">{item.step}</span>
              <h3 className="mt-4 text-lg font-bold text-foreground">{item.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
